module.exports = __webpack_public_path__ + "static/media/import-ing.1b6bc3df.svg";